(function () {
    'use strict';

    const meta = document.querySelector('meta[name="public-settings"]');
    const raw = meta ? meta.getAttribute('content') : '';
    let settings = {};
    try {
        settings = raw ? JSON.parse(raw) : {};
    } catch (e) {
        console.error('[PublicSettings] Failed to parse meta content:', raw, e);
    }

    angular.module('iteroServices').factory('PublicSettings', function () {
        return settings;
    });
})();
